import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {getAllSeasons} from '../../fetch/seasonApi';
import {SeasonType} from '../../types/SeasonType';
import {AppDispatch} from '../../store';

export interface SeasonState {
    seasons: SeasonType[];
}

const initialState: SeasonState = {
    seasons: []
};

const seasonSlice = createSlice({
    name: 'season',
    initialState,
    reducers: {
        seasonsSet: (state, action: PayloadAction<SeasonType[]>) => {
            state.seasons = action.payload;
        }
    }
});

export const {seasonsSet} = seasonSlice.actions;
export default seasonSlice.reducer;

export const loadSeasons = () => (dispatch: AppDispatch) => {
    getAllSeasons(dispatch).then((response) => {
        if (response.success) {
            const sortedSeasons = response.result;
            sortedSeasons.sort((season1: SeasonType, season2: SeasonType) =>
                new Date(season2.startDate).getTime() - new Date(season1.startDate).getTime());

            dispatch(seasonsSet(sortedSeasons));
        }
    });
};
